// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__2g6X1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About.css
// module id = 92
// module chunks = 0